/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one course with credits to see your GPA.`)
};

const es_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade al menos una asignatura con créditos para ver tu promedio.`)
};

const de_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge mindestens einen Kurs mit Credits hinzu, um deinen GPA zu sehen.`)
};

const nl_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg minstens één vak met studiepunten toe om je GPA te zien.`)
};

const fr_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez au moins un cours avec des crédits pour voir votre GPA.`)
};

const it_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi almeno un corso con crediti per vedere il tuo GPA.`)
};

const pt_br2_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione pelo menos uma disciplina com créditos para ver seu GPA.`)
};

const pt_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione pelo menos uma disciplina com créditos para ver o seu GPA.`)
};

const ja_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPAを見るには単位付きの科目を少なくとも1つ追加してください。`)
};

const zh_gpa_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请添加至少一门带学分的课程以查看你的 GPA。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_hint", locale)
	if (locale === "en") return en_gpa_hint(inputs)
	if (locale === "es") return es_gpa_hint(inputs)
	if (locale === "de") return de_gpa_hint(inputs)
	if (locale === "nl") return nl_gpa_hint(inputs)
	if (locale === "fr") return fr_gpa_hint(inputs)
	if (locale === "it") return it_gpa_hint(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_hint(inputs)
	if (locale === "pt") return pt_gpa_hint(inputs)
	if (locale === "ja") return ja_gpa_hint(inputs)
	return zh_gpa_hint(inputs)
};